import type { AsyncReducerState } from '@helpers/makeReducer'
import makeReducer, {
  asyncReducer,
  INITIAL_ASYNC_REDUCER_STATE,
} from '@helpers/makeReducer'

import types from './types'

type LoginState = AsyncReducerState & {
  isLoggedIn: boolean
  isMigrating: boolean
}

export const INITIAL_STATE: LoginState = {
  ...INITIAL_ASYNC_REDUCER_STATE,
  isLoggedIn: false,
  isMigrating: false,
}

export default makeReducer(INITIAL_STATE, {
  ...asyncReducer<LoginState>({
    types: {
      pending: types.AUTH_PENDING,
      fulfilled: types.AUTH_FULFILLED,
      rejected: types.AUTH_REJECTED,
    },
    parsePayload: () => ({
      isMigrating: false,
      isLoggedIn: true,
    }),
  }),

  ...asyncReducer({
    types: {
      pending: types.ACCESS_TOKEN_PENDING,
      fulfilled: types.ACCESS_TOKEN_FULFILLED,
      rejected: types.ACCESS_TOKEN_REJECTED,
    },
  }),

  [types.AUTH_MIGRATION_PENDING]: (state) => ({
    ...state,
    isMigrating: true,
  }),
})
